import React from 'react';
import '../styles/namo_theme.css'

const ParaHead =  (props) => (
  <div className="row namo-div namo-list">&nbsp;{props.txt}</div>
 )

export default ParaHead;
